import { makeType, actionCreator } from "../../Utils/generateActionCreator";
import { API } from "aws-amplify";

const actionType = makeType("REQUESTPDF");

export const DOWNLOAD = actionType("DOWNLOAD");
export const ERR_DOWNLOAD = actionType("ERR_DOWNLOAD");

export const LOADING = actionType("LOADING");

export const downloadSuccess = actionCreator(DOWNLOAD, "data");
export const downloadError = actionCreator(ERR_DOWNLOAD, "error");
export const loading = actionCreator(LOADING, "loading");

export const downloadPdf = async (dispatch, idCotizacion, setLoadingClick) => {
  dispatch(loading(true));
  const response = await API.get("api-rentas", `/generate-pdf/${idCotizacion}`);

  if (response.status) {
    window.open(response.data, "_blank");
    dispatch(downloadSuccess(response.data));
    setLoadingClick(false);
  } else {
    dispatch(downloadError(response));
    setLoadingClick(false);
  }
  dispatch(loading(false));
};
